module.exports = __webpack_public_path__ + "img/onboard.8da826eb.webp";